import { toKebabCase } from "./string";

export function createDataSelector(data) {
	const pairs = [];
	for (const k in data)
		pairs.push(`[data-${toKebabCase(k)}="${data[k]}"]`);
	return pairs.join("");
}

export function findParent(el, selector) {
	while (el && el.parentElement) {
		el = el.parentElement;
		if (el.matches(selector))
			return el;
	}
	return null;
}

export function isFullyVisibleOnScreen(target) {
	const rect = target.getBoundingClientRect();
	const vw = window.innerWidth;
	const vh = window.innerHeight;
	return (
		rect.top >= 0 &&
		rect.left >= 0 &&
		rect.bottom <= vh &&
		rect.right <= vw
	);
}

export function isVisibleOnScreen(target) {
	const rect = target.getBoundingClientRect();
	const vw = window.innerWidth;
	const vh = window.innerHeight;
	if (target.offsetParent === null)
		return false;
	if (rect.bottom <= 0 || rect.top >= vh)
		return false;
	if (rect.right <= 0 || rect.left >= vw)
		return false;
	return true;
}

export function parseDataset(element, meta, prefix = undefined) {
	const options = {};
	for (const k in meta) {
		const dataKey = prefix ? prefix + k.substring(0, 1).toUpperCase() + k.substring(1) : k;
		if (!(dataKey in element.dataset))
			continue;
		switch (meta[k]) {
			case "string":
				options[k] = element.dataset[dataKey];
				break;
			case "number":
				options[k] = parseInt(element.dataset[dataKey]);
				break;
			case "bool":
				options[k] = !(element.dataset[dataKey] == "false" || element.dataset[dataKey] == "0");
				break;
		}
	}
	return options;
}

export async function waitTransitionEnd(element, timeout = 500) {
	return new Promise((resolve) => {
		const onTransitionEnd = (e) => {
			if (e.target != e.currentTarget)
				return;
			resolve();
			element.removeEventListener('transitionend', onTransitionEnd);
			clearTimeout(timerId);
		};
		const timerId = setTimeout(() => {
			resolve();
			element.removeEventListener('transitionend', onTransitionEnd);
			console.error('waitTransitionEnd timeout!');
		}, timeout);
		element.addEventListener('transitionend', onTransitionEnd);
	});
}
